// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-inz {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .popup-inner-inz {
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    width: 500px;
  }

  .popup-header-inz {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .close-icon {
    cursor: pointer;
  }

  .popup-content-inz {
    margin-bottom: 20px;
  }

  .popup-actions-inz {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  .redeem-btn,
  .see-rewards-btn {
    padding: 10px 20px;
    margin: 0 10px;
    border: none;
    border-radius: 5px;
    background-color: rgb(3, 180, 198);;
    color: white;
    cursor: pointer;
  }

  .redeem-btn:hover,
  .see-rewards-btn:hover {
    background-color: rgb(3, 144, 159);;
  }
`, "",{"version":3,"sources":["webpack://./src/MyComponents/MyRewards/MyRewards.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,kCAAkC;EACpC","sourcesContent":[".popup-inz {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .popup-inner-inz {\n    background-color: white;\n    border-radius: 8px;\n    padding: 20px;\n    width: 500px;\n  }\n\n  .popup-header-inz {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n\n  .close-icon {\n    cursor: pointer;\n  }\n\n  .popup-content-inz {\n    margin-bottom: 20px;\n  }\n\n  .popup-actions-inz {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n  }\n\n  .redeem-btn,\n  .see-rewards-btn {\n    padding: 10px 20px;\n    margin: 0 10px;\n    border: none;\n    border-radius: 5px;\n    background-color: rgb(3, 180, 198);;\n    color: white;\n    cursor: pointer;\n  }\n\n  .redeem-btn:hover,\n  .see-rewards-btn:hover {\n    background-color: rgb(3, 144, 159);;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
